/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_4_PInputs */

const en_privacy_4_p = /** @type {(inputs: Privacy_4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments in Indonesian rupiah are handled by Midtrans; payments in US dollars by Paddle, which acts as merchant of record. Bystep never sees or stores your full card number. We keep the order id, amount, payment method and status.`)
};

const id_privacy_4_p = /** @type {(inputs: Privacy_4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran dalam rupiah diproses oleh Midtrans; pembayaran dalam dolar AS oleh Paddle sebagai merchant of record. Bystep tidak pernah melihat atau menyimpan nomor kartumu secara lengkap. Kami menyimpan id pesanan, nominal, metode, dan status pembayaran.`)
};

/**
* | output |
* | --- |
* | "Payments in Indonesian rupiah are handled by Midtrans; payments in US dollars by Paddle, which acts as merchant of record. Bystep never sees or stores your f..." |
*
* @param {Privacy_4_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_4_p = /** @type {((inputs?: Privacy_4_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_4_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_4_p(inputs)
	return en_privacy_4_p(inputs)
});